module.exports = __webpack_public_path__ + "img/JPY.a51fd83b.png";